import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'core-helpers-icons-blue-circle',
  templateUrl: './blue-circle.component.html',
  styleUrls: ['./blue-circle.component.scss'],
})
export class IconsBlueCircleComponent {}
